<template>
  <b-modal
    :visible="!!test"
    :title="$t('efficiencyTestFailures.modal.title')"
    size="lg"
    centered
    @hidden="$emit('close')"
  >
    <p v-if="test" class="font-weight-bold">{{ test.name }}</p>
    <p v-if="loading" class="text-muted mb-0">{{ $t('efficiencyTestFailures.modal.loading') }}</p>
    <failure-list v-else-if="failures.length" :failures="failures"></failure-list>
    <p v-else-if="loaded" class="mb-0">{{ $t(general.textKey) }}</p>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="$emit('close')">{{
        $t('efficiencyTestFailures.modal.close')
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
// The reasons of the last execution of a Failed test, read-only. The list item carries only how many they
// are, so the test is read when the modal opens: `failures[]` of GET /api/efficiencyTests/{id}. A test that
// failed before the reasons were kept has none: the general text, without a part, is all there is to say.
import FailureList from './FailureList.vue'
import { get } from '../../utils/fetcher'
import { failurePresentation } from '../../utils/failurePresentation'

export default {
  components: { FailureList },

  props: {
    // The list item of the test to explain, or null while the modal is closed.
    test: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      failures: [],
      loading: false,
      loaded: false,
    }
  },

  computed: {
    general() {
      return failurePresentation(null)
    },
  },

  watch: {
    test: {
      immediate: true,
      handler(test) {
        this.failures = []
        this.loaded = false
        if (test) {
          this.load(test)
        }
      },
    },
  },

  methods: {
    load(test) {
      const id = test.scoringProfileId || test.id
      this.loading = true
      return get('/api/efficiencyTests/' + id)
        .then((detail) => {
          // Another test may have been opened while this was on its way.
          if (this.test === test) {
            this.failures = (detail && detail.failures) || []
            this.loaded = true
          }
        })
        .catch((err) => {
          this.$emit('close')
          this.httpErrorsHandler(err)
        })
        .finally(() => {
          if (this.test === test) {
            this.loading = false
          }
        })
    },
  },
}
</script>
